import React, { useState, useEffect } from 'react';
import pdfLogo from '../assets/images/pdfLogo.svg';
import docLogo from '../assets/images/docLogo.svg';

export const Thumb = (props) => {
  const [thumb, setThumb] = useState([]);
  const [loading, setLoading] = useState(false);
  const { file } = props;

  useEffect(() => {
    if (
      typeof file !== 'string' &&
      file &&
      ['image/png', 'image/jpeg', 'image/jpg']?.includes(file.type)
    ) {
      setLoading(true);
      let reader = new FileReader();
      reader.onloadend = () => {
        setLoading(false);
        setThumb(reader.result);
      };
      reader.readAsDataURL(file);
    }
    return () => {
      setLoading(false);
      setThumb([]);
    };
  }, [file]);

  if (!file) {
    return null;
  }

  if (loading) {
    return <p>loading...</p>;
  }

  return (
    <>
      {file.type === 'application/pdf' ? (
        <img
          style={{ fontSize: '0.2rem' }}
          src={pdfLogo}
          alt={file.name}
          className="img-thumbnail mt-2 upload-img"
          height={90}
          width={90}
        />
      ) : [
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ]?.includes(file.type) ? (
        <img
          style={{ fontSize: '0.2rem' }}
          src={docLogo}
          alt={file.name}
          className="img-thumbnail mt-2 upload-img"
          height={90}
          width={90}
        />
      ) : (
        <img
          style={{ fontSize: '0.2rem' }}
          src={thumb}
          alt={file.name}
          className="img-thumbnail mt-2 upload-img"
          height={90}
          width={90}
        />
      )}
      <br />
    </>
  );
};

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let image = document.createElement('img');
      image.src = reader.result;
      if (image.height > 800) {
        let canvas = document.createElement('canvas');
        let canvasContext = canvas.getContext('2d');

        while (image.height > 800) {
          image.height = image.height / 2;
          image.width = image.width / 2;
        }

        canvas.width = image.width * 1;
        canvas.height = image.height * 1;
        // canvasContext.scale(0.25, 0.25);
        canvasContext.drawImage(image, 0, 0, canvas.width, canvas.height);

        let base64String = canvas.toDataURL(file.type);
        // resolve(base64String.split(',')[1]);
        resolve(base64String);
      } else {
        // resolve(reader.result.split(',')[1]);
        resolve(reader.result);
      }
    };
    reader.onerror = (error) => reject(error);
  });

export const dataURItoBlob = (dataURI, name) => {
  let byteString = dataURI;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
  // if (dataURI.split(',')[0].indexOf('base64') >= 0)
  //   byteString = Buffer.from(dataURI.split(',')[1], 'base64');
  else byteString = unescape(dataURI.split(',')[1]);
  // else byteString = decodeURI(dataURI.split(',')[1]);

  // separate out the mime component
  let mimeString = dataURI?.split(',')[0]?.split(':')[1]?.split(';')[0];

  // write the bytes of the string to a typed array
  let ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  let file = new Blob([ia], { type: mimeString });
  file.name = name;
  file.lastModifiedDate = new Date();
  return file;
};
